/**
 * Created by elad on 15 נובמבר 2016.
 */
import VueRouter from "vue-router";
import middleware from "src/middleware";
import LoginView from "src/view/auth/LoginView";
import UsersView from "src/view/users/UsersView";
import Dashboard from "./Dashboard";
import ClientsView from "src/view/clients/ClientsView";
import OrdersView from "src/view/orders/OrdersView";
import {types as rolesTypes} from "dev/helpers/RoleManager";
import ReportsView from "dev/view/reports/ReportsView";
import VideoView from "dev/view/video/VideoView";
import ProjectsView from "dev/view/projects/ProjectsView";
import OutSideView from "dev/view/outside/OutSideView";
import ThankView from "dev/view/outside/ThankView";
import CitiesView from "src/view/cities/CitiesView";
import AreasView from "src/view/areas/AreasView";

const routes = [
  {path: "/", redirect: {name: "orders-page"}, name: "home-page"},
  { path: "/login", component: LoginView, name: "login-page" },
  { path: "/register/:id/:client", component: OutSideView, name: "outside-page" },
  { path: "/thank/:uuid", component: ThankView, name: "outside.thank" },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { "RequireAuth": true },
    children: [
      {path: "/users", component: UsersView, name: "users-page"},
      {path: "/surveyors", component: UsersView, props: {type: rolesTypes.SURVEYORS}, name: "surveyors-page"},
      {path: "/officers", component: UsersView, props: {type: rolesTypes.OFFICERS}, name: "officers-page"},
      {path: "/clients", component: ClientsView, name: "client-page"},
      {path: "/orders", component: OrdersView, name: "orders-page"},
      {path: "/projects", component: ProjectsView, name: "projects-page"},
      {path: "/reports", component: ReportsView, name: "reports-page"},
      {path: "/cities", component: CitiesView,props: {type: rolesTypes.OFFICERS}, name: "cities-page"},
      {path: "/areas", component: AreasView, props: {type: rolesTypes.OFFICERS}, name: "areas-page"},
      {path:"/help",component:VideoView,name:"help-page"}

    ]
  }
];

const router = new VueRouter({
  history: false,
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  middleware.check(to, from, next);
});

export default router;
